import {
  FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER,
  FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_FAILURE,
  FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_SUCCESS,
  RESET_TRACKED_ASSEMBLY_GUIDE,
} from "./assemblyGuideTypes";

export const fetchAsssemblyGuideByArticleNumber = ({
  articleNumber,
  lang,
}) => ({
  type: FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER,
  payload: { articleNumber, lang },
});

export const fetchAsssemblyGuideByArticleNumberSuccess = ({ products }) => ({
  type: FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_SUCCESS,
  payload: products,
});

export const fetchAsssemblyGuideByArticleNumberFailure = (error) => ({
  type: FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER_FAILURE,
  payload: error,
});

export const resetTrackedAsssemblyGuide = () => ({
  type: RESET_TRACKED_ASSEMBLY_GUIDE,
});
